import React from 'react'
import clsx from 'clsx'
import useShowMore from 'modules/common/hooks/useShowMore'
import { makeStyles, createStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() =>
  createStyles({
    list: {
      listStyle: 'none',
      paddingLeft: '12px',
      '&>a': {
        fontWeight: 400,
      },
    },
  }),
)

const MenuItem = (props: any) => {
  const { item, renderComponent, isChild } = props

  const { showMoreProps, ShowMore, visibleItems } = useShowMore({
    showMore: item.items,
    limit: 5,
    showMoreLimit: 10,
    items: item.items || [],
  })

  const classes = useStyles()
  const itemHasChildren: boolean = item.items && Boolean(item.items.length)

  return (
    <li
      key={item.key || item.label}
      className={clsx('item', {
        'item--selected': item.isRefined,
        'item--noRefinement': item.noRefinement,
        'item--parent': itemHasChildren,
      })}
    >
      {renderComponent(item, isChild)}
      {itemHasChildren && (
        <ul className={classes.list}>
          {visibleItems.map((item) => (
            <MenuItem
              key={item.key || item.label}
              item={item}
              renderComponent={renderComponent}
              isChild={true}
            />
          ))}
          <ShowMore key="showMore" {...showMoreProps} />
        </ul>
      )}
    </li>
  )
}

export default MenuItem
